<template>
<div class="row primary-filter" v-if="!isLoading">
  <div class="col-10 filter-grid">
    <ul>
      <li class="app-side-menu">
        <span @click="$router.go(-1)" class="pointer">
            <svgicon name="arrow-down" width="20" height="20" :original="true" class="back-arrow" />
        </span>
      </li>

      <li class="category">
        <div class="dropdown">
          <div class="dropdown-selected">
            <span v-if="hideEdits">Invoice</span>
            <span v-else>{{invoiceNo}}</span>
          </div>
        </div>
      </li>
    </ul>
  </div>

  <div class="col-2 filter-grid filter-button" >
    <ul class="filter-btn-group">
      <li v-if="$store.invoice && $store.invoice.status === 4">
        <button class="btn btn-primary" @click="reSubmit">
          Re Submitted
        </button>
      </li>
      <li v-if="hideEdits">
        <button class="btn btn-primary" @click="create">
          Generate Invoice
        </button>
      </li>
      <li v-if="!hideEdits && showPrint">
        <a class="btn btn-primary" target="_blank" :href="url(invoiceId, currentTransporter.id)">
          Print
        </a>
      </li>
    </ul>
  </div>

</div>
</template>

<script>
import { mapGetters } from 'vuex';
import { invoice } from 'pando-payment-request-computation';
import { AdditionalChargesMethod, gstSplitType, gstType, Movement } from 'pando-constants';
import { cloneDeep } from 'lodash';
/* eslint-disable */
export default {
 props: ['paidto'],
 components: {

 },
 data() {
   return {
     invoiceRequestData: null,
   };
 },
 computed: {
   hideEdits() {
     return !this.$store.showInvoice;
   },
   showReSubmit() {
     return [4].includes(this.$store.invoice.status);
   },
   showPrint() {
     return ![1,2,4].includes(this.$store.invoice.status);
   },
   invoiceNo() {
     return this.$store.invoice.invoice_number;
   },
   invoiceId() {
     return this.$store.invoice.id;
   },
   currentTransporterGST() {
     const transporter = this.currentTransporter;
     return transporter.gst_details.find(gst => gst.client_id === this.currentClient.id);
   },
   ...mapGetters({
     isLoading: 'app/isLoading',
     currentTransporter: 'app/currentTransporter',
     currentClient: 'app/currentClient',
     transporterNonGst: 'app/transporterNonGst',
     currentClientConfig: 'app/currentClientConfig',
   }),
    currentClientGst() {
      if (this.currentTransporter && this.currentClient) {
        return this.currentTransporter.gst_details.find(
          gst => gst.client_id === this.currentClient.id,
        );
      }
      return undefined;
    },
    additionalCharges() {
      if (this.currentClientGst) {
        const additionalChargesList = [];
        if (
          this.$hasFeature('transporter_payment_discount') &&
          this.currentClientGst.payment_discount
        ) {
          additionalChargesList.push({
            label: 'discount',
            percentage: this.currentClientGst.payment_discount,
            method: AdditionalChargesMethod.SUBTRACT,
          });
        }
        return additionalChargesList;
      }
      return [];
    },
    invoiceCharges() {
      const data = this.invoiceRequestData;
      const payments = this.$store.payments.selected;
      let totalInvoiceAmount = 0;
      for (let i = 0; i < payments.length; i += 1) {
        const payment = payments[i];

        totalInvoiceAmount += payment.charges.reduce((total, charges) => {
          const { total_amount: totalAmount } = charges;
          return (total + totalAmount.transporter);
        }, 0);
      }

      const additionalChargesList = cloneDeep(this.additionalCharges);
      const serviceRecipientState = payments[0].depot.name;
      const serviceProviderState = data.source_state;
      const isIntraState = (serviceRecipientState === serviceProviderState);
      let computeData = {};
      const igst = data.igst_tax;
      computeData = {
        tax: {
          igst,
          sgst: igst / 2,
          cgst: igst / 2,
        },
        additionalCharges: additionalChargesList,
        total: totalInvoiceAmount,
      };
      const invoiceComputer = new invoice(computeData, this.gsttype,
        isIntraState ? gstSplitType.INTRA_STATE : gstSplitType.INTER_STATE);
      return invoiceComputer.getTotal();
    },
    gsttype() {
      return (this.currentClientGst && this.currentClientGst.type) || gstType.RCM;
    },
  },
 methods: {
   onCloseMenu() {
     // this.isOpen = false;
   },
    url(invoiceId, transporterId) {
      const isDevelopment = process.env.NODE_ENV === 'development';
      const baseURL = isDevelopment ? 'http://localhost:3002/api' : '/api';
      return `${baseURL}/invoice/print/${invoiceId}/${transporterId}`;
    },
   back() {
     // this.isOpen = true;
   },
   async reSubmit() {
    try {
         let hasData = null;
         hasData = await this.$store.dispatch('payment/reSubmit', this.$store.invoice.id);
         if(hasData.data && hasData.data.status !== 204) {
           const message = ( hasData.data.errors && hasData.data.errors[0].message) ? hasData.data.errors[0].message : 'Unable to Process';
           this.$error({ message: message });
           return false;
         } else {
           this.$success({ message: 'Invoice Re-Submitted' });
           await new Promise((resolve)=>setTimeout(()=>resolve(), 1000));
           this.$router.push({ name: 'PaymentList' });
         }
       } catch (e) {
         this.$error({ message: 'Unable to Re-Submitted invoice' });
       }
   },
   async create() {
     const payments = this.$store.payments;
     const destination = (payments.selected[0]) ? payments.selected[0].destination_state: ''; // It should be taken from transporter Profile state
     const service_recipient = (this.paidto) ? parseInt(this.paidto, 10) : this.currentTransporterGST.type;
     const source_state = (payments.selectedState && payments.selectedState.name) ? payments.selectedState.name: destination;
     const gst_number = payments.gstno;
     const gstNumberRefid = payments.gstno_ref_id;
     const igst = (payments.igst_tax) ? payments.igst_tax: payments.selected[0].igst_tax;
     const invoice_number = payments.invoiceno;
     const payment_ids = payments.selected.map(i => i.id);
     // const voucher_id = '';
     if(!payments.selectedState || !payments.selectedState.name) {
        this.$error({ message: 'Please select serivce provider state' });
        return false;
     }
     if (!gst_number || gst_number === '') {
       this.$error({ message: 'Please enter GST Number' });
        return false;
     }

     if (!invoice_number || invoice_number === '') {
       this.$error({ message: 'Please enter invocie Number' });
        return false;
     }

      const wallet_ids = payments.wallet_ids.length ? payments.wallet_ids : [];

     if (gst_number && gst_number !== '' && invoice_number && invoice_number !== '') {
       const params = {
         service_recipient,
         source_state,
         gst_number,
         gstin_ref_id:gstNumberRefid,
         igst_tax: igst,
         invoice_number,
         payment_ids,
         wallet_ids,
        };
       try {
          let v2InvoiceData = null;
          this.invoiceRequestData = params;
          const movement = payments.selected[0] && payments.selected[0].order.movement;
          if (this.currentClientConfig.pay_v1_v2 && movement === Movement.PRIMARY) {
            v2InvoiceData = this.prepDataForV2Invoice(params, movement);
          }
          const invoiceRequest = {
            v1InvoiceRequest: params,
            v2InvoiceRequest: v2InvoiceData,
            isPayV1V2Enabled: this.currentClientConfig.pay_v1_v2,
          };
         let hasData = null;
         hasData = await this.$store.dispatch('payment/createinvoice', invoiceRequest)
         if(hasData.data && hasData.data.status !== 200) {
           const message = ( hasData.data.errors && hasData.data.errors[0].message) ? hasData.data.errors[0].message : 'Unable to Process';
           this.$error({ message: message });
           return false;
         } else {
           this.$success({ message: 'Invoice created' });
           await new Promise((resolve)=>setTimeout(()=>resolve(), 1000));
           this.$router.push({ name: 'PaymentList' });
         }
       } catch (e) {
         this.$error({ message: 'Unable to generate invoice' });
       }
     } else {
       this.$error({ message: 'GST No or Invoice No missing' });
     }
   },
    prepDataForV2Invoice(data, movement) {
      let v2InvoiceData = null;
      if (data) {
        const payments = this.$store.payments;
        const serviceRecipientState = payments.selectedState.name;
        const serviceProviderState = data.source_state;
        const total = this.invoiceCharges.totalAmount;
        v2InvoiceData = {
          invoice_number: data.invoice_number,
          hsn_sac: this.currentClient.hsn_sac,
          invoice_date: new Date().toISOString(),
          gst_number: data.gst_number,
          additional_charges: this.additionalCharges.length ? this.additionalCharges : undefined,
          invoice_amount: total,
          gst_type: this.gsttype,
          tax: {
            source: serviceProviderState, // service provider state selected in UI
            destination: serviceRecipientState,
            igst: data.igst_tax,
            cgst: data.igst_tax / 2,
            sgst: data.igst_tax / 2,
            intra_state: serviceRecipientState === serviceProviderState,
          },
          extra_km: 0,
          movement,
          order_references: payments.selected.map(payment => payment.order_number),
          client_id: payments.selected[0].client_id,
        };
      }
      return v2InvoiceData;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@common/styles-transporter/settings";

.back-arrow {
  transform: rotate(90deg);
}

.primary-filter {
    border: 1px solid #DEE5E6;
    background-color: #fff;
    height: 50px;
    margin-left: -20px;
    margin-right: -20px;
    font-family:$fontSemibold;
    .dropdown-menu {
        top: 32px !important;
    }
    .filter-grid {
        padding-left: 0;
        padding-right: 0;
        // border-left: 1px solid #CBD4D8;
        ul {
            @extend %list-unstyled;
            li {
                display: inline-block;
            }
            .app-side-menu {
                // background-color: #F2F1F1;
                padding: 14px 0;
                width: 69px;
                text-align: center;
                position: relative;
                top: -3px;
                background: #F2F1F1;
                cursor: pointer;
            }
            .category {
                width: 180px;
                padding: 5px 20px;
                color: #007FEA;
                padding-left: 10px;
                border-right: 1px solid #CBD4D8;
                border-left: 1px solid #CBD4D8;
                font-size: 1.4rem;
                text-transform: uppercase;
                margin-left: -3px;
                position: relative;
                top: -1px;
                height: 50px;
                .dropdown {
                    padding: 12px 10px;
                }
            }
            .search {
                padding: 0 20px;
                width: 50%;
                svg {
                    position: relative;
                    top: 0px;
                }
                input {
                    outline: none;
                    border: 1px solid transparent;
                    padding: 0 5px;
                    width: 90%;
                    font-size: 1.4rem;
                }
            }
        }
        &.filter-button {
            ul {
                @extend %list-unstyled;
                float: right;
                padding: 9.5px 10px;
                li {
                    margin: 0 0 0 18px;
                    &:last-child {
                        margin: 0 0 0 10px;
                    }
                    .btn-primary {
                        @extend %header-primary-btn;
                        @extend %bold;
                        color: #fff;
                        text-transform: uppercase;
                    }
                    .btn-secondary {
                        @extend %header-secondary-btn;
                        @extend %bold;
                        color: #008AFF;
                        text-transform: uppercase;
                    }
                }
            }
        }
    }
}
.hidden {
  visibility: hidden;
}
</style>
